module.exports = __webpack_public_path__ + "static/media/uppdate.8c82b075.svg";